import { SendOutlined } from '@ant-design/icons'
import React from 'react'
import { useTranslation } from 'react-i18next'

import { AppHeader, ColumnLayout } from '@/components'
import { PostsContainer } from '@/modules/post/posts.container'

export const AllPostsContainer = () => {
  const { t } = useTranslation()

  const header = <AppHeader title={t('admin.allPosts')} avatar={<SendOutlined />} />

  const middle = <PostsContainer isAllPosts={true} />

  return <ColumnLayout header={header} middle={middle} />
}
